import React from 'react'
import Header1 from '../components/Header1'
import Footer from '../components/Footer'
import SiemensCaseStudyComponent from '../components/SiemenscaseStudyComponent'
import SiemensContext from '../components/SiemensContext'
import ProblemBeneathTheSurface from '../components/ProblemBeneathTheSurface'
import ProplusTranslatedGtm from '../components/ProplusTranslatedGtm'
import ProplusImpact from '../components/ProplusImpact'
import IntelligenceImpact from '../components/IntelligenceImpact'
import WhatWeDidDifferently from '../components/WhatWeDidDifferently'
import TheDifferentItMade from '../components/TheDifferentItMade'
import SiemensUseCaseGraph from '../components/SiemensUseCaseGraph'
import SiemensSummary from '../components/SiemenSummary'
import TestimonialSection from '../components/TestimonialSection'


export default function HowaFortune500ManufacturerTransformedGtmWithProPlus() {
  return (
    <div>
      <Header1/>
      <SiemensCaseStudyComponent/>
      <SiemensContext/>
      <ProblemBeneathTheSurface/>
      <ProplusTranslatedGtm/>
      <ProplusImpact/>
      <IntelligenceImpact/>
      <WhatWeDidDifferently/>
      <SiemensUseCaseGraph/>
      <TheDifferentItMade/>
      <SiemensSummary/>
      <TestimonialSection/>
      <Footer/>
    </div>
  )
}
